var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnfoldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6576_14022",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6576_14022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7314 14.0003L6.38281 8.63367L7.61219 7.4043L14.2082 14.0003L7.61219 20.5964L6.38281 19.367L11.7314 14.0003ZM19.1397 14.0003L13.7911 8.63367L15.0205 7.4043L21.6166 14.0003L15.0205 20.5964L13.7911 19.367L19.1397 14.0003Z",
    fill: "#878A93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfoldIcon);
export default __webpack_public_path__ + "static/media/unfold-icon.73ca948de7c0c78dd6f0771239bae86b.svg";
export { ForwardRef as ReactComponent };